var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("suggestionsController",
    ["$scope", "$rootScope", "$location", "suggestionsService", "loaderService", "validationService",
        function ($scope, $rootScope, $location, suggestionsService, loaderService, validationService) {

            var acceptedFileTypes = [
                'art','stx','pes','pec','dat','dsb','dst','emd','exp','exy','hus','jef', 'ksm', 'pcm', 'pcq', 'pcs', 'sew', 'tap', 'vip', 'xxx', 'zsk', 'pdf', 'doc', 'docx', 'rtf', 'jpg', 'jpeg', 'gif', 'png', 'bmp', 'xls', 'xlsx'
            ];

            $scope.onSuggestionsSubmit = function(form){
                var form_data = new FormData();
                $scope.isAttachmentSizeValid = true;
                $scope.isAttachmentTypeValid = true;
                if (angular.isDefined($scope.suggestions.attachment)) {
                    if ($scope.suggestions.attachment.size > 2000000) {
                        $scope.isAttachmentSizeValid = false;
                    }
                    if($scope.isAttachmentSizeValid && acceptedFileTypes.indexOf($scope.getFileExtension($scope.suggestions.attachment.name)) < 0){
                        $scope.isAttachmentTypeValid = false;
                    }
                    form_data.append('file', $scope.suggestions.attachment);
                }
                if( form.$valid &&
                    form.$submitted &&
                    $scope.isAttachmentTypeValid &&
                    $scope.isAttachmentSizeValid &&
                    $scope.suggestions.recaptchaResponse != '' &&
                    confirm("Are you sure to submit your Suggestion?")
                ){
                    loaderService.show();
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'feedback_submit', {
                            'event_category': 'engagement',
                            'event_action': 'feedback_submit',
                            'event_label': 'footer_link'
                        });
                    }
                    var suggestion = {
                        FirstName: $scope.suggestions.firstName,
                        LastName: $scope.suggestions.lastName,
                        PhoneNumber: $scope.suggestions.phonenumber,
                        Organization: $scope.suggestions.organisation,
                        Email: $scope.suggestions.email,
                        IsWebsite: $scope.suggestions.about.toLowerCase() == "website",
                        IsProduct: $scope.suggestions.about.toLowerCase() == "product",
                        RelatedSection: $scope.suggestions.relatedSection,
                        SuggestedProductName: $scope.suggestions.suggestedPrdName,
                        UserSuggestion: $scope.suggestions.userSuggestion,
                    };
                    form_data.append(
                        "suggestions", angular.toJson(suggestion)
                    );
                    form_data.append(
                        "g-Recaptcha-Response", $scope.suggestions.recaptchaResponse
                    );
                    suggestionsService.submitSuggestion(form_data).then(function(response){
                        if(response && response.data){
                            loaderService.hide();
                            if(response.data.isSent){
                                $scope.resetSuggestion();
                                $rootScope.$emit("ShowNotificationModal", {
                                    modalKey: "SuggestionSuccess",
                                    redirectOnOkUrl: "/suggestions",
                                    redirectOnCloseUrl: "/suggestions",
                                });
                            }
                            else{
                                $rootScope.notificationMsg = response.data.message;
                                $rootScope.$emit("ShowNotificationModal", {
                                    modalKey: "SuggestionError",
                                    redirectOnOkUrl: "/suggestions",
                                    redirectOnCloseUrl: "/suggestions",
                                });
                            }
                        }
                    });
                }
            }

            $scope.initialize = function(){
                $scope.resetSuggestion();
                $scope.getUrlHashedFilters();
                $scope.regularExpressions = validationService.getRegularExpressions();
            }

            $scope.resetSuggestion = function(){
                $scope.suggestions = {
                    email: "",
                    firstName: "",
                    lastName: "",
                    about: "website",
                    organisation: "",
                    phonenumber: null,
                    relatedSection: "",
                    userSuggestion: "",
                    areTermsAgreed: true,
                    suggestedPrdName: "",
                    attachment: undefined,
                };
                if(angular.isDefined($scope.suggestionsForm)){
                    $scope.suggestionsForm.$submitted = false;
                }
            }

            $scope.getUrlHashedFilters = function () {
                var params = $location.search();
                if (angular.isDefined(params)) {
                    if(angular.isDefined(params.pg) && params.pg.toLowerCase() == 'product'){
                        $scope.suggestions.about = 'product';
                    }
                }
            }

            $scope.getFileExtension = function (filename) {
                return filename.substr((filename.lastIndexOf('.')+1));
            }

        }
    ]
);
